import { memo, type ReactNode } from 'react';

import { WORKSPACE_PANEL_COLLAPSE_SLOT_CLASS } from '~/components/v2/components/shared/page-header/pageHeaderLayout';
import { WorkspacePanelCollapseSlot } from '~/components/v2/components/shared/page-header/WorkspacePanelCollapseSlot';
import { useWorkspaceSplitPageTopbar } from '~/components/v2/components/shared/panel/useWorkspaceSplitPageTopbar';

export type PageHeaderTrailingSlotProps = {
  children?: ReactNode;
};

/** Right column: collapse when split, otherwise the page's own trailing actions. */
export const PageHeaderTrailingSlot = memo(({ children }: PageHeaderTrailingSlotProps) => {
  const showSplitPageTopbar = useWorkspaceSplitPageTopbar();

  if (showSplitPageTopbar) {
    return (
      <div className={WORKSPACE_PANEL_COLLAPSE_SLOT_CLASS}>
        <WorkspacePanelCollapseSlot />
      </div>
    );
  }

  if (!children) {
    return null;
  }

  return <>{children}</>;
});

PageHeaderTrailingSlot.displayName = 'PageHeaderTrailingSlot';
